<div cdkDrag cdkDragBoundary="body" [cdkDragFreeDragPosition]="location" (cdkDragEnded)="storeLocation($event)" data-test-id="css-filters-container">
  <div class="css-filters" data-test-id="css-filters">
    <div class="css-filter">
      <div class="form-label active-filter-label" cdkDragHandle>
        <span>{{ filter | case: "start" }}</span>
        <span>&nbsp;</span>
        <span>{{ filterz[filter].value | number: "1." + filterz[filter].dp }}</span>
        <span>{{ filterz[filter].uom.displayUnit }}</span>
      </div>
      <div class="active-filter">
        <input
          type="range"
          class="form-range"
          [min]="min"
          [max]="max"
          [step]="step"
          [ngModel]="filterz[filter].value"
          (ngModelChange)="sliderUpdateFilterValue($event)"
        />
      </div>
    </div>

    <div class="buttons">
      <button class="btn btn-reset" title="Reset" (click)="resetFilter()">
        <span class="material-icons-round notranslate">loop</span>
      </button>
      <button class="btn btn-toggle" title="Toggle Dialog" (click)="toggleDialog()">
        <span class="material-icons-round notranslate" [class.expanded]="showDialog">expand_more</span>
      </button>
    </div>
  </div>

  <ng-container *ngIf="showDialog">
    <app-css-filters-dialog
      [filters]="filterz"
      [filter]="filter"
      [target]="target"
      [targetValue]="targetValue"
      (changeFilter)="changeFilter($event)"
      (updateTarget)="updateTarget($event)"
      (updateOrder)="updateOrder($event)"
      (resetAll)="resetAll()"
      (colorBlind)="colorBlind($event)"
    >
    </app-css-filters-dialog>
  </ng-container>
</div>
